import { ShowDetailState } from './types/reducerTypes'
import { AnyAction } from 'redux'

const SET_SHOW_DETAILS_DATA = 'SET_SHOW_DETAILS_DATA'
const RESET_SHOW_DETAILS_DATA = 'RESET_SHOW_DETAILS_DATA'

const defaultState: ShowDetailState = {
  collections: [],
  pageDetails: {},
  continueWatchingData: {
    contentDescription: '',
    contentHasSecondsWatched: false,
    contentSecondsWatched: null,
    contentDuration: null,
    contentSeason: null,
    contentEpisode: null,
    contentTitle: '',
    contentMezzanineImage: '',
    contentUrl: '',
    contentResourceType: '',
  },
}

export default function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case SET_SHOW_DETAILS_DATA:
      return { ...state, ...action.payload }
    case RESET_SHOW_DETAILS_DATA:
      return defaultState
    default:
      return state
  }
}
